import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import PageLayout from "../components/PageLayout.jsx";
import SvgIcon from "../components/SvgIcon.jsx";
import DownloadButton from "../components/DownloadButton.jsx";

export default function Research() {
  const { t } = useTranslation();
  const [error, setError] = useState(false);

  const fileDownload = async (fileName) => {
    try {
      setError(false);
      const url = new URL(window.location.href);
      url.pathname = fileName;
      window.open(url.toString(), "_blank");
    } catch (error) {
      console.error("Error fetching resources for download:", error);
      setError(true);
    }
  };

  return (
    <PageLayout title="Research and Presentations">
      <h1 className="mb-2 text-center">{t("research.title")}</h1>
      <ul className="mx-auto mt-4 max-w-(--breakpoint-md) divide-y divide-gray-100 rounded-md border border-gray-200">
        <li className="flex items-center justify-between py-4 pr-5 pl-4 leading-6">
          <div className="flex w-0 flex-1 items-center">
            <div className="ml-4 flex min-w-0 flex-1 flex-col gap-1">
              <span className="inline-flex items-center gap-1 truncate font-medium">
                {t("research.symposium2023.title")}
                <a
                  className="text-proof-blue hover:underline"
                  href="https://sensoryhealth.org/basic/welcome-to-2023-star-sensory-symposium"
                  target="_blank"
                >
                  <SvgIcon type="link" />
                </a>
              </span>
              <span className="inline-flex gap-1 truncate text-sm font-medium">{t("research.symposium2023.type")}</span>
              <span className="text-sm font-light">{t("research.symposium2023.desc")}</span>
            </div>
          </div>
          <div className="ml-2 w-40 shrink-0">
            <div className="flex w-40 items-center justify-center bg-gray-100">
              <DownloadButton file="/files/PROOF-STARSymposiumPoster.pdf" onClick={fileDownload} isImage={true}>
                <img alt="Symposium Poster" src="/images/PROOF-STARSymposiumPoster-600px.png" />
              </DownloadButton>
            </div>
          </div>
        </li>
        <li className="flex items-center justify-between py-4 pr-5 pl-4 leading-6">
          <div className="flex w-0 flex-1 items-center">
            <div className="ml-4 flex min-w-0 flex-1 flex-col gap-1">
              <span className="inline-flex items-center gap-1 truncate font-medium">
                {t("research.otExchange2024.title")}
                <a
                  className="text-proof-blue hover:underline"
                  href="https://www.otausevents.com.au/otexchange2024/"
                  target="_blank"
                >
                  <SvgIcon type="link" />
                </a>
              </span>
              <span className="inline-flex gap-1 truncate text-sm font-medium">
                {t("research.otExchange2024.type")}
              </span>
              <span className="text-sm font-light">{t("research.otExchange2024.desc")}</span>
            </div>
          </div>
        </li>
        <li className="flex items-center justify-between py-4 pr-5 pl-4 leading-6">
          <div className="flex w-0 flex-1 items-center">
            <div className="ml-4 flex min-w-0 flex-1 flex-col gap-1">
              <span className="inline-flex items-center gap-1 truncate font-medium">
                {t("research.oregonOt2024.title")}
                <a
                  className="text-proof-blue hover:underline"
                  href="https://www.otao.com/2024-Conference"
                  target="_blank"
                >
                  <SvgIcon type="link" />
                </a>
              </span>
              <span className="inline-flex gap-1 truncate text-sm font-medium">{t("research.oregonOt2024.type")}</span>
              <span className="text-sm font-light">{t("research.oregonOt2024.desc")}</span>
            </div>
          </div>
        </li>
        <li className="flex items-center justify-between py-4 pr-5 pl-4 leading-6">
          <div className="flex w-0 flex-1 items-center">
            <div className="ml-4 flex min-w-0 flex-1 flex-col gap-1">
              <span className="inline-flex items-center gap-1 truncate font-medium">
                {t("research.journal2024.title")}
              </span>
              <span className="text-sm font-light">{t("research.journal2024.desc")}</span>
              <span className="inline-flex gap-1 truncate text-sm font-medium">
                <DownloadButton file="/files/PROOF-SupplementalMaterials-26Oct2024.pdf" onClick={fileDownload}>
                  {t("research.journal2024.type")}
                </DownloadButton>
              </span>
            </div>
          </div>
        </li>
        <li className="flex items-center justify-between py-4 pr-5 pl-4 leading-6">
          <div className="flex w-0 flex-1 items-center">
            <div className="ml-4 flex min-w-0 flex-1 flex-col gap-1">
              <span className="inline-flex items-center gap-1 truncate font-medium">
                {t("research.caseStudy2025.title")}
              </span>
              <span className="text-sm font-light">{t("research.caseStudy2025.desc")}</span>
            </div>
          </div>
        </li>
        <li className="flex items-center justify-between py-4 pr-5 pl-4 leading-6">
          <div className="flex w-0 flex-1 items-center">
            <div className="ml-4 flex min-w-0 flex-1 flex-col gap-1">
              <span className="inline-flex items-center gap-1 truncate font-medium">
                {t("research.conference2025.title")}
                <a
                  className="text-proof-blue hover:underline"
                  href="https://childtraumaconference.org/au"
                  target="_blank"
                >
                  <SvgIcon type="link" />
                </a>
              </span>
              <span className="inline-flex gap-1 truncate text-sm font-medium">
                {t("research.conference2025.type")}
              </span>
              <span className="text-sm font-light">{t("research.conference2025.desc")}</span>
            </div>
          </div>
        </li>
      </ul>
      {error && (
        <div className="mt-2 text-center text-sm text-red-800">
          <Trans i18nKey="resources.downloadError">
            An error occurred please{" "}
            <a className="font-medium underline hover:opacity-50" href="/resources">
              reload the page
            </a>{" "}
            and try again
          </Trans>
        </div>
      )}
    </PageLayout>
  );
}
